const { formatCurrency } = require('@/lib/Formatting/currency');
const { getService } = require('@/lib/DI/injector');

/**
 * @param {Number} input
 * @param {Number} [decimalCount]
 * @returns {string}
 */
const currencyFilter = (input, decimalCount = 2) => {
    const currencyService = getService('currencyService');

    return formatCurrency(currencyService, input, decimalCount);
};

module.exports = {
    currencyFilter,
};
